export default "__VITE_ASSET__CHiTJFmG__"